const WA_BUSINESS_CATEGORIES = [
  { value: 'UNDEFINED', label: '未定義' },
  { value: 'OTHER', label: '其他' },
  { value: 'AUTO', label: '汽車' },
  { value: 'BEAUTY', label: '美容' },
  { value: 'APPAREL', label: '服飾' },
  { value: 'EDU', label: '教育' },
  { value: 'ENTERTAIN', label: '娛樂' },
  { value: 'EVENT_PLAN', label: '活動策劃' },
  { value: 'FINANCE', label: '金融' },
  { value: 'GROCERY', label: '雜貨' },
  { value: 'GOVT', label: '政府' },
  { value: 'HOTEL', label: '酒店' },
  { value: 'HEALTH', label: '醫療健康' },
  { value: 'NONPROFIT', label: '非營利組織' },
  { value: 'PROF_SERVICES', label: '專業服務' },
  { value: 'RETAIL', label: '零售' },
  { value: 'TRAVEL', label: '旅遊' },
  { value: 'RESTAURANT', label: '餐飲' },
  { value: 'NOT_A_BIZ', label: '非商業' },
];

export default WA_BUSINESS_CATEGORIES;
